import { t } from "./strings";

const key = "liyu.appearance";
const system = window.matchMedia("(prefers-color-scheme: dark)");
let preference: "light" | "dark" | null = null;
try {
  const saved = localStorage.getItem(key);
  if (saved === "light" || saved === "dark") preference = saved;
} catch {
  // Theme switching still works when browser storage is unavailable.
}

function mode() {
  return preference ?? (system.matches ? "dark" : "light");
}

export function refreshAppearance() {
  const current = mode();
  document.documentElement.dataset.theme = current;
  document.documentElement.style.colorScheme = current;
  const button = document.getElementById("themeToggle");
  if (button) button.textContent = t(current === "dark" ? "common.lightMode" : "common.darkMode");
}

refreshAppearance();
system.addEventListener("change", refreshAppearance);
window.addEventListener("storage", (event) => {
  if (event.key !== key) return;
  preference = event.newValue === "light" || event.newValue === "dark" ? event.newValue : null;
  refreshAppearance();
});
document.getElementById("themeToggle")?.addEventListener("click", () => {
  preference = mode() === "dark" ? "light" : "dark";
  try {
    localStorage.setItem(key, preference);
  } catch {
    // Keep the in-memory preference for this visit.
  }
  refreshAppearance();
});
